<section class="teams" id="teams">
  <div class="container padding">
    <div class="teams__header">
      <h2 class="teams__title">{{ 'teams.title' | translate }}</h2>
      <div class="teams__title-divider"></div>
      <p class="teams__subtitle">{{ 'teams.subtitle' | translate }}</p>
    </div>

    <div class="teams__grid d-none d-md-grid">
      @for (member of teamMembers; track member.id) {
      <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: member }"></ng-container>
      }
    </div>

    <div class="teams__mobile d-flex d-md-none">
      <div class="teams__mobile-slider" #teamSlider>
        @for (member of teamMembers; track member.id) {
        <div class="teams__mobile-card-wrapper">
          <ng-container *ngTemplateOutlet="memberCard; context: { $implicit: member }"></ng-container>
        </div>
        }
      </div>
    </div>
  </div>
</section>

<ng-template #memberCard let-member>
  <article class="teams__member">
    <div class="teams__member-image">
      <img [src]="member.image" [alt]="'teams.member' + member.id + '_name' | translate" class="teams__member-img" [ngClass]="member.class || ''" />
    </div>
    <div class="teams__member-body">
      <h3 class="teams__member-name">{{ 'teams.member' + member.id + '_name' | translate }}</h3>
      <p class="teams__member-role">{{ 'teams.member' + member.id + '_role' | translate }}</p>

      <div class="teams__member-info-wrap">
        <a *ngIf="member.link" class="teams__member-info-icon" [href]="member.link" target="_blank">
        </a>
        <button *ngIf="!member.link" class="teams__member-info-btn" type="button" aria-label="More information">
          <span class="teams__member-info-btn-icon">i</span>
        </button>
        @if(member.toolTip){
          <span  class="teams__member-tooltip">
            {{ 'teams.member' + member.id + '_info' | translate }}
          </span>
        }
      </div>
    </div>
  </article>
</ng-template>